import { render } from "./LottoRecentView.vue?vue&type=template&id=572d0b81&ts=true"
import script from "./LottoRecentView.vue?vue&type=script&lang=ts"
export * from "./LottoRecentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__